
/*
 HYDROLIFE CART DRAWER - VERSION 9
 Til EGO Cart Upsell

 - Én sammenhængende mobilscroll
 - Produktanbefalinger med tilbudspriser
 - Ingen manuel rabatkode
 - Bevarer automatisk anvendte rabatter
 - Besparelse og subtotal
 - Kompakt abonnementsmærke
 - Små handelsbetingelser
 - Mørkeblå betalingsknap med hængelås
 - Én række betalingslogoer
 - Grønne tillidsstjerner
*/

(function () {
  "use strict";

  if (window.__hydrolifeCartV9) return;
  window.__hydrolifeCartV9 = true;

  const ROOT = window.Shopify?.routes?.root || "/";
  const TERMS_URL = "/policies/terms-of-service";

  const PRODUCTS = {
    bottle: {
      handle: "hydrobottle-pro",
      description:
        "Lav frisk hydrogenvand igen og igen med HydroBottle™ Pro."
    },
    sleeve: {
      handle: "beskyttelsessleeve-til-hydrobottle™-pro",
      description:
        "Beskyt din HydroBottle™ Pro mod ridser og skader."
    }
  };

  const PANEL = "hl-v9-recommendations";
  const TOTAL = "hl-v9-totals";
  const TERMS = "hl-v9-terms";
  const PAYMENTS = "hl-v9-payments";
  const TRUST = "hl-v9-trust";
  const STYLE = "hl-v9-styles";

  const cache = new Map();
  let running = false;
  let pending = false;

  const css = `

    /* =========== FJERN GAMLE ELEMENTER =========== */

    #cart-drawer-container .opus-carousel-container,
    #cart-drawer-container .hydrolife-cart-recommendations,
    #cart-drawer-container .hydrolife-total-savings,
    #cart-drawer-container .hydrolife-payment-row,
    #cart-drawer-container .hydrolife-trust-row,
    #cart-drawer-container .hl-v7-recommendations,
    #cart-drawer-container .hl-v7-totals,
    #cart-drawer-container .hl-v7-discount,
    #cart-drawer-container .hl-v7-terms,
    #cart-drawer-container .hl-v7-trust,
    #cart-drawer-container .hl-v7-payments,
    #cart-drawer-container .hl-v8-recommendations,
    #cart-drawer-container .hl-v8-totals,
    #cart-drawer-container .hl-v8-terms,
    #cart-drawer-container .hl-v8-trust,
    #cart-drawer-container .hl-v8-payments,
    .cart-protection-toggle,
    .cart-protection-v2,
    [data-cart-protection-toggle],
    [data-cart-protection-v2] {
      display: none !important;
    }

    #cart-drawer-container .hl-v9-hidden {
      display: none !important;
    }

    /* =========== MOBILSCROLL =========== */

    @media (max-width: 767px) {

      #cart-drawer-container {
        height: 100dvh !important;
        max-height: 100dvh !important;
        overflow: hidden !important;
        display: flex !important;
        flex-direction: column !important;
      }

      /*
       EGO's header bliver øverst.
       Den øvrige kurv scroller som ét område.
      */

      #cart-drawer-container .cd-opus-container {
        display: flex !important;
        flex-direction: column !important;
        flex: 1 1 auto !important;
        min-height: 0 !important;
        height: auto !important;
        max-height: 100% !important;

        overflow-x: hidden !important;
        overflow-y: auto !important;

        -webkit-overflow-scrolling: touch !important;
        overscroll-behavior-y: contain;
        touch-action: pan-y !important;
      }

      /*
       De indre områder må ikke have
       hver deres selvstændige scroll.
      */

      #cart-drawer-container .cd-app-scroll-list,
      #cart-drawer-container .cd-main-scroll-list {
        display: block !important;
        flex: 0 0 auto !important;

        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;

        overflow: visible !important;
      }

      #cart-drawer-container .cd-product-list {
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        overflow: visible !important;
      }

      #cart-drawer-container .cd-product-item {
        min-height: 0 !important;
      }

      #cart-drawer-container .${PANEL} {
        position: relative !important;
        flex: 0 0 auto !important;
        height: auto !important;
      }

      #cart-drawer-container .bottom-section {
        position: relative !important;
        top: auto !important;
        bottom: auto !important;

        flex: 0 0 auto !important;

        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;

        overflow: visible !important;
        transform: none !important;

        padding-bottom:
          calc(25px + env(safe-area-inset-bottom, 0px))
          !important;
      }
    }

    /* =========== ANBEFALINGER =========== */

    #cart-drawer-container .${PANEL} {
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      margin: 10px 0 12px;
      width: 100%;
      box-sizing: border-box;
      font-family: inherit;
    }

    #cart-drawer-container .${PANEL} * {
      box-sizing: border-box;
    }

    #cart-drawer-container .hl-v9-heading {
      font-size: 15px;
      font-weight: 800;
      color: #111;
      text-transform: uppercase;
      margin: 0 0 14px;
    }

    #cart-drawer-container .hl-v9-item {
      display: grid;
      grid-template-columns: 76px minmax(0, 1fr);
      align-items: center;
      gap: 12px;
      padding: 9px 0;
    }

    #cart-drawer-container .hl-v9-image {
      display: block;
      width: 76px;
      height: 76px;
      border-radius: 8px;
      object-fit: cover;
    }

    #cart-drawer-container .hl-v9-link {
      color: #203c71 !important;
      text-decoration: none !important;
    }

    #cart-drawer-container .hl-v9-link:hover {
      text-decoration: underline !important;
    }

    #cart-drawer-container .hl-v9-name {
      display: block;
      font-size: 13px;
      font-weight: 800;
      line-height: 1.35;
      margin-bottom: 4px;
    }

    #cart-drawer-container .hl-v9-description {
      font-size: 11px;
      line-height: 1.4;
      color: #657387;
      margin: 0 0 8px;
    }

    #cart-drawer-container .hl-v9-price-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 8px;
    }

    #cart-drawer-container .hl-v9-current-price {
      color: #111;
      font-size: 13px;
      font-weight: 800;
    }

    #cart-drawer-container .hl-v9-old-price {
      margin-left: 6px;
      color: #929ba8;
      font-size: 11px;
      text-decoration: line-through;
    }

    #cart-drawer-container .hl-v9-add {
      background: #087fbb;
      color: white;
      border: none;
      border-radius: 7px;
      padding: 10px 13px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 750;
    }

    #cart-drawer-container .hl-v9-add:disabled {
      opacity: .55;
      cursor: wait;
    }

    #cart-drawer-container .hl-v9-select {
      display: block;
      width: 100%;
      padding: 7px;
      margin-top: 8px;
      border: 1px solid #cbd7e2;
      border-radius: 6px;
      background: #fff;
      color: #203c71;
    }

    /* =========== BESPARING OG SUBTOTAL =========== */

    #cart-drawer-container .${TOTAL} {
      color: #253b68;
      margin: 7px 0 13px;
    }

    #cart-drawer-container .hl-v9-total-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      padding: 8px 0;
      font-size: 13px;
    }

    #cart-drawer-container .hl-v9-total-row strong {
      font-weight: 800;
      white-space: nowrap;
    }

    #cart-drawer-container .hl-v9-subtotal {
      border-top: 1px solid rgba(36,59,104,.13);
      padding-top: 12px;
      font-size: 15px;
      font-weight: 800;
    }

    #cart-drawer-container .hl-v9-before {
      color: #929baa;
      font-size: 12px;
      font-weight: 400;
      text-decoration: line-through;
      margin-right: 8px;
    }

    /* =========== HANDELSBETINGELSER =========== */

    #cart-drawer-container .${TERMS} {
      display: flex !important;
      align-items: flex-start !important;
      gap: 9px !important;
      margin: 13px 0 !important;

      color: #292929 !important;
      font-size: 12px !important;
      line-height: 1.5 !important;
      font-weight: 400 !important;

      letter-spacing: normal !important;
      text-transform: none !important;
    }

    #cart-drawer-container .${TERMS} input {
      width: 17px !important;
      height: 17px !important;
      flex: 0 0 17px !important;
      margin: 1px 0 0 !important;
      accent-color: #1946a0;
      cursor: pointer;
    }

    #cart-drawer-container .${TERMS} label {
      display: inline !important;
      color: #292929 !important;
      font-size: 12px !important;
      line-height: 1.5 !important;
      font-weight: 400 !important;
      letter-spacing: normal !important;
      text-transform: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    #cart-drawer-container .${TERMS} a {
      color: #1946a0 !important;
      font-size: inherit !important;
      font-weight: 400 !important;
      letter-spacing: normal !important;
      text-transform: none !important;
      text-decoration: underline !important;
    }

    #cart-drawer-container .hl-v9-terms-error {
      display: none;
      font-size: 11px;
      color: #b42318;
      margin: 0 0 9px;
    }

    /* =========== BETALINGSKNAP =========== */

    #cart-drawer-container .hl-v9-checkout {
      position: relative !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      min-height: 52px !important;

      background: #1946a0 !important;
      color: #fff !important;
      border-radius: 11px !important;

      overflow: hidden !important;
      isolation: isolate;
      text-align: center !important;
    }

    #cart-drawer-container
    .hl-v9-checkout > .hl-v9-original {
      visibility: hidden !important;
    }

    #cart-drawer-container .hl-v9-checkout-label {
      position: absolute !important;
      inset: 0 !important;

      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      gap: 8px !important;

      padding: 8px !important;
      z-index: 3 !important;
      pointer-events: none !important;

      color: white !important;
      font-size: clamp(12px, 3.4vw, 16px) !important;
      font-weight: 800 !important;
      line-height: 1.3 !important;
      text-align: center !important;
    }

    #cart-drawer-container .hl-v9-checkout::after {
      content: "";
      position: absolute;
      top: -60%;
      bottom: -60%;
      left: -75%;
      width: 32%;

      transform: skewX(-20deg);
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255,255,255,.38),
        transparent
      );

      pointer-events: none;
      z-index: 2;
    }

    @media (hover:hover) {
      #cart-drawer-container .hl-v9-checkout:hover {
        background: #103779 !important;
      }

      #cart-drawer-container .hl-v9-checkout:hover::after {
        animation: hl-v9-shine .85s ease forwards;
      }
    }

    @keyframes hl-v9-shine {
      to { left: 140%; }
    }

    /* =========== BETALINGSLOGOER =========== */

    #cart-drawer-container .${PAYMENTS} {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5px;

      width: 100%;
      margin: 10px 0 5px;
      overflow-x: auto;
      scrollbar-width: none;
    }

    #cart-drawer-container
    .${PAYMENTS}::-webkit-scrollbar {
      display: none;
    }

    #cart-drawer-container
    .${PAYMENTS} .hl-pay-icon {
      display: flex;
      align-items: center;
      justify-content: center;

      flex: 1 1 0;
      min-width: 0;
      max-width: 62px;
      height: 31px;

      padding: 2px;
      background: #fff;
      border: 1px solid #e4eaf1;
      border-radius: 5px;
    }

    #cart-drawer-container
    .${PAYMENTS} .hl-pay-icon svg {
      width: 100%;
      height: 100%;
      max-height: 27px;
    }

    #cart-drawer-container
    .${PAYMENTS} .hl-shop-pay {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #5a31f4;
      color: #fff;
      border-radius: 4px;

      font-weight: 800;
      width: 100%;
      height: 100%;
    }

    /* =========== TILLIDSSTJERNER =========== */

    #cart-drawer-container .${TRUST} {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      gap: 9px 15px;
      padding: 11px 3px;

      color: #283e69;
      font-size: 11px;
      font-weight: 700;
    }

    #cart-drawer-container .hl-v9-trust-item {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      white-space: nowrap;
    }

    #cart-drawer-container .hl-v9-star {
      color: #12b981;
      font-size: 17px;
      line-height: 1;
    }

    /* =========== ABONNEMENT =========== */

    #cart-drawer-container .hl-v9-subscription {
      display: inline-flex !important;
      justify-content: center !important;
      align-items: center !important;

      width: max-content !important;
      max-width: 100% !important;

      height: auto !important;
      min-height: 0 !important;

      flex: 0 0 auto !important;
      align-self: flex-start !important;

      border: 1px dashed #7a889b !important;
      border-radius: 20px !important;

      background: transparent !important;
      color: #293e61 !important;

      padding: 3px 10px !important;
      margin: 5px 0 0 !important;

      font-size: 11px !important;
      line-height: 1.3 !important;
      font-weight: 500 !important;

      letter-spacing: normal !important;
      text-transform: none !important;
      white-space: nowrap !important;
    }

    @media (max-width:380px) {
      #cart-drawer-container .hl-v9-item {
        grid-template-columns: 65px minmax(0,1fr);
        gap: 9px;
      }

      #cart-drawer-container .hl-v9-image {
        width: 65px;
        height: 65px;
      }

      #cart-drawer-container .${TRUST} {
        gap: 7px 9px;
        font-size: 10px;
      }
    }
  `;

  /* =========== SHOPIFY API =========== */

  async function api(path, options = {}) {
    const response = await fetch(ROOT + path, {
      credentials: "same-origin",
      cache: "no-store",
      ...options
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        "Shopify kunne ikke gennemføre handlingen."
      );
    }

    return data;
  }

  async function getProduct(handle) {
    if (cache.has(handle)) {
      return cache.get(handle);
    }

    try {
      const product = await api(
        "products/" + encodeURIComponent(handle) + ".js"
      );

      cache.set(handle, product);
      return product;

    } catch (error) {
      console.warn("[Hydrolife V9]", handle, error);
      return null;
    }
  }

  function money(cents) {
    return (Number(cents || 0) / 100).toLocaleString(
      "da-DK",
      {
        style: "currency",
        currency: window.Shopify?.currency?.active || "DKK"
      }
    );
  }

  /* =========== SHADOW DOM =========== */

  function getRoots() {
    const roots = [document];
    const visited = new Set();

    function scan(root) {
      if (visited.has(root)) return;
      visited.add(root);

      root.querySelectorAll("*").forEach(el => {
        if (el.shadowRoot) {
          roots.push(el.shadowRoot);
          scan(el.shadowRoot);
        }
      });
    }

    scan(document);
    return roots;
  }

  function addStyles(root) {
    if (root.querySelector("#" + STYLE)) return;

    const style = document.createElement("style");
    style.id = STYLE;
    style.textContent = css;

    (root === document ? document.head : root)
      .appendChild(style);
  }

  /* =========== HJÆLPEFUNKTIONER =========== */

  function findCheckout(footer) {
    const existing = footer.querySelector(
      ".hl-v9-checkout"
    );

    if (existing) return existing;

    return [...footer.querySelectorAll(
      "button,a,[role='button']"
    )].find(el => {
      if (el.closest("." + PANEL)) return false;

      const t = (
        (el.textContent || "") +
        " " +
        String(el.className || "")
      ).toLowerCase();

      return (
        t.includes("gå til betaling") ||
        t.includes("gå til kassen") ||
        t.includes("sikker betaling") ||
        t.includes("checkout")
      );
    });
  }

  function directChild(parent, child) {
    let el = child;

    while (
      el?.parentElement &&
      el.parentElement !== parent
    ) {
      el = el.parentElement;
    }

    return el?.parentElement === parent ? el : null;
  }

  /* =========== PRODUKTANBEFALINGER =========== */

  function createCard(entry) {
    const variants = entry.product.variants.filter(
      v => v.available
    );

    if (!variants.length) return null;

    let selected = variants[0];

    const card = document.createElement("article");
    card.className = "hl-v9-item";

    const url = ROOT + "products/" +
      encodeURIComponent(entry.product.handle);

    const imageLink = document.createElement("a");
    imageLink.href = url;
    imageLink.className = "hl-v9-link";
    imageLink.setAttribute(
      "aria-label",
      "Se " + entry.product.title
    );

    const img = document.createElement("img");
    img.className = "hl-v9-image";
    img.loading = "lazy";
    img.alt = entry.product.title;
    img.src = entry.product.featured_image ||
      entry.product.images?.[0] || "";

    imageLink.appendChild(img);

    const content = document.createElement("div");

    const name = document.createElement("a");
    name.href = url;
    name.className = "hl-v9-link hl-v9-name";
    name.textContent = entry.product.title;

    const description = document.createElement("p");
    description.className = "hl-v9-description";
    description.textContent = entry.description;

    const priceLine = document.createElement("div");
    priceLine.className = "hl-v9-price-line";

    const prices = document.createElement("div");

    const current = document.createElement("span");
    current.className = "hl-v9-current-price";

    const old = document.createElement("span");
    old.className = "hl-v9-old-price";

    function updatePrice() {
      current.textContent = money(selected.price);

      const compare = Number(
        selected.compare_at_price || 0
      );

      const onSale = compare > Number(selected.price);

      old.textContent = onSale ? money(compare) : "";
      old.style.display = onSale ? "inline" : "none";
    }

    updatePrice();
    prices.append(current, old);

    const button = document.createElement("button");
    button.type = "button";
    button.className = "hl-v9-add";
    button.textContent = "Tilføj";

    button.addEventListener("click", async () => {
      button.disabled = true;
      button.textContent = "Tilføjer…";

      try {
        await api("cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: selected.id,
                quantity: 1
              }
            ]
          })
        });

        location.reload();

      } catch (error) {
        button.disabled = false;
        button.textContent = "Prøv igen";
        alert(error.message);
      }
    });

    priceLine.append(prices, button);
    content.append(name, description, priceLine);

    if (variants.length > 1) {
      const select = document.createElement("select");
      select.className = "hl-v9-select";
      select.setAttribute("aria-label", "Vælg variant");

      variants.forEach(variant => {
        const option = document.createElement("option");
        option.value = variant.id;
        option.textContent = variant.title;
        select.appendChild(option);
      });

      select.addEventListener("change", () => {
        selected = variants.find(
          v => String(v.id) === select.value
        ) || variants[0];

        updatePrice();
      });

      content.appendChild(select);
    }

    card.append(imageLink, content);
    return card;
  }

  function updateRecommendations(
    drawer,
    footer,
    entries,
    signature
  ) {
    const panels = [
      ...drawer.querySelectorAll("." + PANEL)
    ];

    const existing = panels[0];
    panels.slice(1).forEach(el => el.remove());

    if (!entries.length) {
      existing?.remove();
      return;
    }

    if (
      existing &&
      existing.dataset.signature === signature
    ) {
      return;
    }

    existing?.remove();

    const panel = document.createElement("section");
    panel.className = PANEL;
    panel.dataset.signature = signature;

    const heading = document.createElement("h3");
    heading.className = "hl-v9-heading";
    heading.textContent = "Mange køber også";

    panel.appendChild(heading);

    entries.forEach(entry => {
      const card = createCard(entry);
      if (card) panel.appendChild(card);
    });

    const carousel = drawer.querySelector(
      ".opus-carousel-container"
    );

    if (carousel?.parentNode) {
      carousel.insertAdjacentElement(
        "afterend",
        panel
      );
    } else {
      footer.parentNode?.insertBefore(panel, footer);
    }
  }

  /* =========== PRISER OG BESPARELSER =========== */

  async function calculateBefore(cart) {
    let before = 0;

    for (const item of cart.items || []) {
      const quantity = Number(item.quantity || 0);

      let unit = Number(
        item.original_price ?? item.price ?? 0
      );

      if (
        item.handle &&
        !item.selling_plan_allocation
      ) {
        const product = await getProduct(item.handle);

        const variant = product?.variants?.find(
          v => Number(v.id) === Number(item.variant_id)
        );

        if (variant) {
          unit = Math.max(
            unit,
            Number(variant.compare_at_price || 0)
          );
        }
      }

      before += unit * quantity;
    }

    return Math.max(
      before,
      Number(cart.total_price || 0)
    );
  }

  function updateTotals(footer, cart, before) {
    let box = footer.querySelector("." + TOTAL);

    if (!box) {
      box = document.createElement("div");
      box.className = TOTAL;
    }

    const actual = Number(cart.total_price || 0);
    const savings = Math.max(0, before - actual);

    box.innerHTML = `
      <div class="hl-v9-total-row hl-v9-saving">
        <span>Du sparer i alt</span>
        <strong class="hl-v9-saving-amount"></strong>
      </div>

      <div class="hl-v9-total-row hl-v9-subtotal">
        <span>Subtotal</span>
        <div>
          <span class="hl-v9-before"></span>
          <strong class="hl-v9-now"></strong>
        </div>
      </div>
    `;

    box.querySelector(".hl-v9-saving").style.display =
      savings > 0 ? "flex" : "none";

    box.querySelector(".hl-v9-saving-amount").textContent =
      "-" + money(savings);

    box.querySelector(".hl-v9-before").textContent =
      savings > 0 ? money(before) : "";

    box.querySelector(".hl-v9-now").textContent =
      money(actual);

    if (!box.isConnected) {
      const checkout = findCheckout(footer);
      const anchor = checkout &&
        directChild(footer, checkout);

      if (anchor) {
        footer.insertBefore(box, anchor);
      } else {
        footer.prepend(box);
      }
    }

    footer.querySelectorAll(
      "[data-subtotal],.cart__subtotal,.cart__savings"
    ).forEach(el => {
      if (!el.closest("." + TOTAL)) {
        el.classList.add("hl-v9-hidden");
      }
    });

    // Skjul eventuel gammel EGO-besparelse.
    [...footer.querySelectorAll("div,span,p")]
      .filter(el =>
        el.children.length === 0 &&
        /^Du sparer i alt$/i.test(
          (el.textContent || "").trim()
        )
      )
      .forEach(el => {
        const parent = el.parentElement;

        if (
          parent &&
          !parent.closest("." + TOTAL) &&
          !parent.querySelector("button,input,a") &&
          (parent.textContent || "").length < 100
        ) {
          parent.classList.add("hl-v9-hidden");
        }
      });
  }

  /* =========== HANDELSBETINGELSER =========== */

  function updateTerms(footer) {
    if (footer.querySelector("." + TERMS)) return;

    const row = document.createElement("div");
    row.className = TERMS;

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className = "hl-v9-terms-check";

    const label = document.createElement("label");
    const id = "hl-v9-terms-checkbox";

    checkbox.id = id;
    label.setAttribute("for", id);

    label.textContent =
      "Jeg accepterer handelsbetingelserne. ";

    const link = document.createElement("a");
    link.href = TERMS_URL;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = "Læs her";

    label.appendChild(link);
    row.append(checkbox, label);

    const error = document.createElement("p");
    error.className = "hl-v9-terms-error";
    error.textContent =
      "Du skal acceptere handelsbetingelserne.";

    const checkout = findCheckout(footer);
    const anchor = checkout &&
      directChild(footer, checkout);

    if (anchor) {
      footer.insertBefore(row, anchor);
      footer.insertBefore(error, anchor);
    } else {
      footer.append(row, error);
    }

    checkbox.addEventListener("change", () => {
      error.style.display = "none";
    });

    link.addEventListener("click", e => {
      e.stopPropagation();
    });
  }

  /* =========== BETALINGSKNAP =========== */

  function updateCheckout(footer, cart) {
    const button = findCheckout(footer);

    if (!button) return;

    button.classList.add("hl-v9-checkout");

    let label = button.querySelector(
      ".hl-v9-checkout-label"
    );

    if (!label) {
      const original = document.createElement("span");
      original.className = "hl-v9-original";

      while (button.firstChild) {
        original.appendChild(button.firstChild);
      }

      button.appendChild(original);

      label = document.createElement("span");
      label.className = "hl-v9-checkout-label";
      label.setAttribute("aria-hidden", "true");

      button.appendChild(label);
    }

    label.innerHTML = `
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.4"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true">
        <rect x="4" y="10"
              width="16" height="11" rx="2"/>
        <path d="M8 10V7a4 4 0 0 1 8 0v3"/>
      </svg>
      <span>
        Gå til sikker betaling · ${money(cart.total_price)}
      </span>
    `;

    button.setAttribute(
      "aria-label",
      "Gå til sikker betaling – " +
      money(cart.total_price)
    );

    if (!button.dataset.hlV9Bound) {
      button.addEventListener(
        "click",
        event => {
          const checkbox = footer.querySelector(
            ".hl-v9-terms-check"
          );

          if (checkbox && !checkbox.checked) {
            event.preventDefault();
            event.stopImmediatePropagation();

            const error = footer.querySelector(
              ".hl-v9-terms-error"
            );

            if (error) {
              error.style.display = "block";
            }

            checkbox.focus();
          }
        },
        true
      );

      button.dataset.hlV9Bound = "1";
    }
  }

  /* =========== ABONNEMENTSMÆRKE =========== */

  
function updateSubscriptions(drawer, cart) {
  const lines = [
    ...drawer.querySelectorAll(".cd-product-item")
  ];

  // Fjern først de mærker, vi selv har tilføjet.
  lines.forEach(line => {
    line.querySelectorAll(".hl-v9-subscription")
      .forEach(badge => badge.remove());
  });

  // Shopify kan have samme variant i kurven både
  // som engangskøb og som abonnement.
  const cartItems = cart.items || [];

  // Brug kun entydige abonnementskendetegn.
  lines.forEach(line => {
    const text = (line.textContent || "").toLowerCase();

    const hasSellingPlanText =
      /hver måned|hver 30\.? dag|abonnement|subscription/i
        .test(text);

    // Spring engangskøb over.
    if (!hasSellingPlanText) return;

    // Undgå at lade vores eget mærke afgøre,
    // om der er tale om et abonnement.
    const match = cartItems.find(item =>
      item.selling_plan_allocation &&
      text.includes(
        (item.product_title || "").toLowerCase()
      )
    );

    if (!match) return;

    const badge = document.createElement("span");
    badge.className = "hl-v9-subscription";
    badge.textContent = "Abonnement";

    const target = line.querySelector(
      ".cd-product-item-details"
    ) || line.querySelector(
      ".cd-product-item-content"
    ) || line;

    target.appendChild(badge);
  });
}


  /* =========== BETALINGSLOGOER =========== */

  function updatePayments(drawer, footer) {
    const template = document.getElementById(
      "hydrolife-payment-icons-template"
    );

    if (!template) return;

    let row = footer.querySelector("." + PAYMENTS);

    if (!row) {
      row = document.createElement("div");
      row.className = PAYMENTS;
      row.setAttribute(
        "aria-label",
        "Betalingsmetoder"
      );

      row.innerHTML = template.innerHTML.trim();
    }

    if (!row.isConnected) {
      const checkout = findCheckout(footer);
      const anchor = checkout &&
        directChild(footer, checkout);

      if (anchor) {
        anchor.insertAdjacentElement(
          "afterend",
          row
        );
      } else {
        footer.appendChild(row);
      }
    }

    // Skjul den oprindelige logorække.
    const selectors = [
      "ul.payment-icons",
      "ul.cart-payment-icons",
      ".opus-payment-icons",
      ".cart-payment-icons",
      ".payment-methods",
      ".payment-methods-list",
      ".payment-icons",
      '[class*="payment-icons"]'
    ];

    drawer.querySelectorAll(
      selectors.join(",")
    ).forEach(el => {
      if (
        el !== row &&
        !el.contains(row) &&
        !el.closest("." + PAYMENTS)
      ) {
        el.classList.add("hl-v9-hidden");
      }
    });

    // EGO kan have betalingsikoner uden klasse.
    const icons = [
      ...footer.querySelectorAll("img,svg")
    ].filter(el => !el.closest("." + PAYMENTS));

    const handled = new Set();

    icons.forEach(icon => {
      let parent = icon.parentElement;

      for (
        let depth = 0;
        depth < 5 && parent;
        depth++
      ) {
        if (
          parent === footer ||
          parent.contains(row) ||
          handled.has(parent)
        ) {
          break;
        }

        const count = parent.querySelectorAll(
          "img,svg"
        ).length;

        const text = (
          parent.textContent || ""
        ).trim();

        const hasCheckout = parent.querySelector(
          "button,a[href*='checkout']"
        );

        if (
          count >= 3 &&
          count <= 10 &&
          text.length < 100 &&
          !hasCheckout
        ) {
          parent.classList.add("hl-v9-hidden");
          handled.add(parent);
          break;
        }

        parent = parent.parentElement;
      }
    });
  }

  /* =========== TILLIDSSTJERNER =========== */

  function updateTrust(footer) {
    if (footer.querySelector("." + TRUST)) return;

    const row = document.createElement("div");
    row.className = TRUST;

    const items = [
      "+3500 glade kunder",
      "1-3 dages levering",
      "Dansk kundeservice"
    ];

    items.forEach(text => {
      const item = document.createElement("span");
      item.className = "hl-v9-trust-item";

      const star = document.createElement("span");
      star.className = "hl-v9-star";
      star.setAttribute("aria-hidden", "true");
      star.textContent = "★";

      const label = document.createElement("span");
      label.textContent = text;

      item.append(star, label);
      row.appendChild(item);
    });

    footer.appendChild(row);
  }

  /* =========== RENDER =========== */

  async function render() {
    if (running) {
      pending = true;
      return;
    }

    running = true;

    try {
      const cart = await api("cart.js");

      const hasBottle = (cart.items || []).some(
        item =>
          item.handle === PRODUCTS.bottle.handle ||
          /^hydrobottle(?:™)? pro$/i.test(
            item.product_title || ""
          )
      );

      const hasTablets = (cart.items || []).some(
        item =>
          /hydrogentabletter/i.test(
            (item.handle || "") +
            " " +
            (item.product_title || "")
          )
      );

      const wanted = hasBottle
        ? ["sleeve"]
        : hasTablets
          ? ["bottle"]
          : [];

      const entries = [];

      for (const type of wanted) {
        const product = await getProduct(
          PRODUCTS[type].handle
        );

        if (
          product?.variants?.some(v => v.available) &&
          !(cart.items || []).some(
            item =>
              Number(item.product_id) ===
              Number(product.id)
          )
        ) {
          entries.push({
            product,
            description: PRODUCTS[type].description
          });
        }
      }

      const before = await calculateBefore(cart);

      const signature = JSON.stringify({
        products: entries.map(e => e.product.id),
        items: (cart.items || []).map(i => [
          i.variant_id,
          i.quantity
        ])
      });

      getRoots().forEach(root => {
        addStyles(root);

        const drawer = root.querySelector(
          "#cart-drawer-container"
        );

        if (!drawer) return;

        const footer = drawer.querySelector(
          ".bottom-section"
        );

        if (!footer) return;

        updateRecommendations(
          drawer,
          footer,
          entries,
          signature
        );

        updateTotals(footer, cart, before);

        updateTerms(footer);

        updateCheckout(footer, cart);

        updatePayments(drawer, footer);

        updateTrust(footer);

        updateSubscriptions(drawer, cart);
      });

    } catch (error) {
      console.warn(
        "[Hydrolife V9] Kurvfejl:",
        error
      );

    } finally {
      running = false;

      if (pending) {
        pending = false;
        setTimeout(render, 350);
      }
    }
  }

  /* =========== EVENTS =========== */

  document.addEventListener(
    "DOMContentLoaded",
    render
  );

  window.addEventListener(
    "load",
    render
  );

  [
    "cart:updated",
    "cart:refresh",
    "cart:added",
    "cart:change",
    "OpusCartChange",
    "OpusSetCartData",
    "OpusAddToCartComplete",
    "OpusRefreshCart"
  ].forEach(event => {
    document.addEventListener(event, render);
    window.addEventListener(event, render);
  });

  // EGO kan opdatere kurven uden sideskift.
  setInterval(() => {
    const visible = getRoots().some(root => {
      const drawer = root.querySelector(
        "#cart-drawer-container"
      );

      return drawer &&
        drawer.getBoundingClientRect().width > 0;
    });

    if (visible) render();
  }, 2500);

  render();

})();
